import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Row, Form, FormGroup, Input, Col, Pagination, PaginationItem, PaginationLink, Label } from 'reactstrap'
import EssentialsCompaniesTable from './EssentialsCompaniesTable'
import LoadingSpinner from '../Shared/LoadingSpinner'
import PageContainer from '../Shared/LayoutComponents/PageContainer'
import PageHeading from '../Shared/LayoutComponents/PageHeading'
import useFetchingEssentialsReconCompanies from './useFetchingEssentialsReconCompanies'

let ShowCompletedCol = styled(Col)`
  padding-top: 7px;
  padding-left: 50px;
`

const EssentialsReconciliation = (props) => {
  useFetchingEssentialsReconCompanies()
  let pageSize = 10
  const [companies, setCompanies] = useState([])
  const [filteredCompanies, setfilteredCompanies] = useState([])
  const [searchCompany, setSearchCompany] = useState('')
  const [includeCompleted, setIncludeCompleted] = useState(true)
  const [pagesCount, setPagesCount] = useState(Math.ceil(props.companyList && props.companyList.length / pageSize))
  const [currentPage, setCurrentPage] = useState(0)

  const handleCompletedToggle = () => {
    if (!includeCompleted) {
      setfilteredCompanies(companies)
      let newPageSize = Math.ceil(companies && companies.length / pageSize)
      setPagesCount(newPageSize)
    } else {
      let newFilter = companies.filter((company) => {
        return company.hasPendingThisMonth === true
      })
      let newPageSize = Math.ceil(newFilter && newFilter.length / pageSize)
      setfilteredCompanies(newFilter)
      setPagesCount(newPageSize)
    }
    setIncludeCompleted(!includeCompleted)
  }

  const handleSearchChange = (event) => {
    setSearchCompany(event.target.value)

    let filteredCompanies = companies

    if (event.target.value !== '') {
      filteredCompanies = filteredCompanies.filter((company) => {
        return company.name.toLowerCase().indexOf(searchCompany.toLowerCase()) !== -1
      })
    }

    setfilteredCompanies(filteredCompanies)
  }

  const firstUpdate = useRef(true)
  // useEffect and firstUpdate to only set the company and filtered state once loaded from api.
  useEffect(() => {
    if (props.companyList && props.companyList.length > 0) {
      if (firstUpdate.current) {
        firstUpdate.current = false
        setCompanies(props.companyList)
        setfilteredCompanies(props.companyList)
        if (!includeCompleted) {
          setfilteredCompanies(props.companyList)
          let newPageSize = Math.ceil(props.companyList && props.companyList.length / pageSize)
          setPagesCount(newPageSize)
        } else {
          let newFilter = props.companyList.filter((company) => {
            return company.hasPendingThisMonth === true
          })
          let newPageSize = Math.ceil(newFilter && newFilter.length / pageSize)
          setfilteredCompanies(newFilter)
          setPagesCount(newPageSize)
        }
        setIncludeCompleted(!includeCompleted)
        return
      }
    }
  }, [props.companyList])

  if (props.loading) {
    return <LoadingSpinner />
  } else {
    return (
      <PageContainer>
        <Row>
          <PageHeading fullWidth={true}>Essentials Reconciliation</PageHeading>
        </Row>
        <div>
          <Pagination aria-label="Page navigation example" style={{ float: 'right' }}>
            <PaginationItem disabled={currentPage <= 0}>
              <PaginationLink onClick={() => setCurrentPage(currentPage - 1)} previous href="#" />
            </PaginationItem>
            {[...Array(pagesCount)].map((page, i) => (
              <PaginationItem active={i === currentPage} key={i}>
                <PaginationLink onClick={() => setCurrentPage(i)} href="#">
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage >= pagesCount - 1}>
              <PaginationLink onClick={() => setCurrentPage(currentPage + 1)} next href="#" />
            </PaginationItem>
          </Pagination>
        </div>
        <Form>
          <FormGroup row>
            <Col sm={4}>
              <Input
                onChange={handleSearchChange}
                value={searchCompany}
                type="search"
                name="search"
                id="Search"
                placeholder="Search for a company"
              />
            </Col>
            <ShowCompletedCol sm={3}>
              <Label check>
                <Input type="checkbox" id="ShowCompleted" onChange={() => handleCompletedToggle()} /> Show Completed
              </Label>
            </ShowCompletedCol>
          </FormGroup>
        </Form>
        <EssentialsCompaniesTable currentPage={currentPage} pageSize={pageSize} companies={filteredCompanies} />
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  loading: state.recon.loading,
  companyList: state.recon.essentialsCompanyList,
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(EssentialsReconciliation)
